import { render } from "./EntraIntuneConfigs.vue?vue&type=template&id=04879da9&scoped=true"
import script from "./EntraIntuneConfigs.vue?vue&type=script&lang=js"
export * from "./EntraIntuneConfigs.vue?vue&type=script&lang=js"

import "./EntraIntuneConfigs.vue?vue&type=style&index=0&id=04879da9&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04879da9"]])

export default __exports__